<!-- ======================================================================================= 
 * ====================================== TEMPLATE =========================================
 * ========================================================================================= -->
<template>
  <div class="flex flex-col">
    <div>
      <header class="z-50 shadow w-screen fixed">
        <nav
          class="flex items-center relative justify-between flex-wrap bg-white px-6 py-2"
        >
          <div class="flex items-center flex-no-shrink text-white mr-6">
            <a class="my-2" href="#inicio">
              <img :src="logo" alt width="110" height="110" />
            </a>
          </div>
          <div class="special-view-menu">
            <slide>
              <a
                href="#nosotros"
                class="no-underline sm-txt-al block mt-4 font-semibold align-text-top text-xl"
                >Nosotros</a
              >
              <a
                href="#expertos"
                class="no-underline sm-txt-al block mt-4 font-semibold align-text-top text-xl"
                >Expertos</a
              >
              <a
                href="#por-que-nosotros"
                class="no-underline sm-txt-al block mt-4 font-semibold align-text-top text-xl"
                >¿Por qué nosotros?</a
              >
              <a
                href="#unete"
                class="no-underline sm-txt-al block mt-4 font-semibold align-text-top text-xl"
                >Únete</a
              >
              <a
                href="https://www.facebook.com/Indecmexico/"
                class="self-end block mt-4"
              >
                <img class="w-10 sm:mx-0" :src="facebook" alt="Whatsapp" />
              </a>
              <a
                href="https://wa.me/5213328207272?texto=Me%20gustaría%20distribuir%20con%20ustedes.`"
                class="no-underline block mt-4"
              >
                <img class="w-10" :src="whatsapp" alt="Whatsapp" />
              </a>
            </slide>
          </div>
          <div class="w-full special-view items-center sm:flex sm:w-auto">
            <div class="text-sm special-view">
              <a
                href="#nosotros"
                class="no-underline sm-txt-al block mt-4 sm:inline-block sm:mt-0 font-semibold align-text-top text-xl mr-4"
                >Nosotros</a
              >
              <a
                href="#expertos"
                class="no-underline sm-txt-al block mt-4 sm:inline-block sm:mt-0 align-text-top font-semibold text-xl mr-4"
                >Expertos</a
              >
              <a
                href="#por-que-nosotros"
                class="no-underline sm-txt-al block mt-4 sm:inline-block sm:mt-0 align-text-top font-semibold text-xl mr-4"
                >¿Por qué nosotros?</a
              >
              <a
                href="#unete"
                class="no-underline sm-txt-al block self mt-4 sm:inline-block sm:mt-0 align-text-top font-semibold text-xl mr-4"
                >Únete</a
              >
              <a
                href="https://www.facebook.com/Indecmexico/"
                class="self-end block mt-4 sm:inline-block align-text-top sm:mt-0"
              >
                <img class="w-10 sm:mx-0" :src="facebook" alt="Whatsapp" />
              </a>
              <a
                href="https://wa.me/5213328207272?texto=Me%20gustaría%20distribuir%20con%20ustedes.`"
                class="no-underline block mt-4 sm:inline-block align-text-top sm:mt-0"
              >
                <img class="w-10" :src="whatsapp" alt="Whatsapp" />
              </a>
            </div>
          </div>
        </nav>
      </header>
      <div class="mt-16 w-full" id="inicio">
        <agile :autoplay-speed="14000" :speed="2500" pause-on-hover autoplay>
          <div class="slide relative">
            <!-- <video class="image-border" autoplay src="../assets/images/INDEC.mp4" /> -->
            <video class="video-border image-border" muted autoplay loop>
              <source :src="videoIndec" type="video/mp4" />
            </video>
            <!-- <img  :src="image1" alt /> -->
            <!-- <div class="flex flex-col absolute child-4">
              <div class="custom-bg-transparent pl-0 mx-0">
                <h1
                  class="text-left text-sm-ts text-white sm:pl-4 font-semi-title"
                >“El producto correcto</h1>
              </div>
              <div class="sp-br"></div>
              <div class="custom-bg-transparent">
                <h1
                  class="text-sm-ts text-white font-semi-title sm:pl-4 pl-12"
                >en el momento preciso”</h1>
              </div>
            </div>-->
          </div>

          <div class="slide relative">
            <img class="rounded-custom" :src="image2" alt />
            <div class="flex flex-col absolute child-4">
              <div class="custom-bg-transparent pl-0 mx-0">
                <h1
                  class="text-left text-sm-ts text-white sm:pl-4 font-semi-title"
                >
                  “El producto correcto
                </h1>
              </div>
              <div class="sp-br"></div>
              <div class="custom-bg-transparent">
                <h1 class="text-sm-ts text-white font-semi-title sm:pl-4 pl-12">
                  en el momento preciso”
                </h1>
              </div>
            </div>
          </div>
          <div class="slide relative">
            <img class="rounded-custom" :src="image3" alt />
            <div class="flex flex-col absolute child-4">
              <div class="custom-bg-transparent pl-0 mx-0">
                <h1
                  class="text-left text-sm-ts text-white sm:pl-4 font-semi-title"
                >
                  “El producto correcto
                </h1>
              </div>
              <div class="sp-br"></div>
              <div class="custom-bg-transparent">
                <h1 class="text-sm-ts text-white font-semi-title sm:pl-4 pl-12">
                  en el momento preciso”
                </h1>
              </div>
            </div>
          </div>
          <div class="slide relative">
            <img class="rounded-custom" :src="image4" alt />
            <div class="flex flex-col absolute child-4">
              <div class="custom-bg-transparent pl-0 mx-0">
                <h1
                  class="text-left text-sm-ts text-white sm:pl-4 font-semi-title"
                >
                  “El producto correcto
                </h1>
              </div>
              <div class="sp-br"></div>
              <div class="custom-bg-transparent">
                <h1 class="text-sm-ts text-white font-semi-title sm:pl-4 pl-12">
                  en el momento preciso”
                </h1>
              </div>
            </div>
          </div>
          <template slot="prevButton">
            <img class="arrow-buton" :src="leftArrow" alt="left" />
          </template>
          <template slot="nextButton">
            <img class="arrow-buton" :src="next" alt="right" />
          </template>
        </agile>
      </div>
    </div>
    <section id="nosotros">
      <div class="flex relative py-n-sp">
        <div
          class="absolute left-center special-view right-center top-0 special-padding"
        >
          <transition name="fade">
            <div
              v-if="show"
              class="flex special-view justify-center items-center custom-bg-blue"
            >
              <h1 class="font-semi text-white nosotros-title pd-nosotros">
                Nosotros
              </h1>
            </div>
          </transition>
        </div>
        <div class="half-section special-view">
          <img class="img-height" :src="nosotros" alt="Nosotros" />
        </div>
        <transition name="fade">
          <div
            v-if="show"
            class="half-section flex flex-col section-sp1 justify-center"
          >
            <div
              class="flex special-view-menu justify-center margin-sp-n items-center custom-bg-blue"
            >
              <h1 class="font-semi text-white text-6xl">Nosotros</h1>
            </div>
            <div class="pxs-text">
              <p class="font-semi text-left-sp">
                ¡Bienvenidos! Somos una empresa mexicana que nace de la
                necesidad de las distintas industrias para la distribución
                confiable y eficaz de envases de plástico.
              </p>
              <!-- <p class="font-semi text-left-sp">que nace de la necesidad de las distintas</p>
            <p class="font-semi text-left-sp">industrias para la distribución confiable</p>
              <p class="font-semi text-left-sp">y eficaz de envases de plástico.</p>-->
            </div>
            <div class="mt-5 pxs-text">
              <p class="font-semi text-left-sp">
                Nuestra logística y efectividad de distribución son nuestros
                valores más importantes por lo que llegamos a sus manos de forma
                segura y a tiempo. Especializandonos en el ¿cómo? ¿cuándo? y
                ¿cuánto?, asegurando el buen manejo y almacenamiento de
                materiales.
              </p>
              <!-- <p class="font-semi text-left-sp">son nuestros valores más importantes por lo</p>
            <p class="font-semi text-left-sp">que llegamos a sus manos de forma segura y a</p>
            <p class="font-semi text-left-sp">tiempo. Especializandonos en el ¿cómo?</p>
            <p class="font-semi text-left-sp">¿cuándo? y ¿cuánto?, asegurando el buen</p>
              <p class="font-semi text-left-sp">manejo y almacenamiento de materiales.</p>-->
            </div>
            <div class="custom-bg-primary self-end px-6 rounded-l-lg my-8">
              <p class="font-semi-title text-white text-2xl">
                Clientes Satisfechos
              </p>
            </div>
            <div class="flex justify-center">
              <div class="list-clients">
                <ul class="list-disc">
                  <li class="font-semi-title mb-3 text-xl text-left">
                    De la Rosa
                  </li>
                  <li class="font-semi-title mb-3 text-xl text-left">Cenmex</li>
                </ul>
              </div>
              <div class="list-clients">
                <ul class="list-disc">
                  <li class="font-semi-title mb-3 text-xl text-left">
                    La Flor de Cordoba
                  </li>
                  <li class="font-semi-title mb-3 text-xl text-left">
                    Distribuidores Casther
                  </li>
                </ul>
              </div>
              <div></div>
            </div>
          </div>
        </transition>
      </div>
    </section>
    <section id="expertos">
      <div class="custom-bg-primary container-expert relative py-16">
        <div class="half-section flex flex-col items-center padding-expert">
          <h1
            class="text-white custom-widt-exp2 text-left text-exp font-semi-title"
          >
            Somos
          </h1>
          <div class="bg-white mx-8 custom-widt-exp2">
            <h1 class="text-exp font-semi-title">Expertos</h1>
          </div>
          <div class="flex expert-images justify-between my-10">
            <div class="flex flex-col">
              <img class="expert-img-icon" :src="logistica" alt="logistica" />
              <h3 class="text-white mt-4 font-semi-title text-xl">Logística</h3>
            </div>
            <div class="flex flex-col">
              <img
                class="expert-img-icon"
                :src="distribucion"
                alt="distribucion"
              />
              <h3 class="text-white mt-4 w-32 font-semi-title text-xl">
                Distribución Envases de Plastico
              </h3>
            </div>
          </div>
        </div>
        <div class="flex items-center w-1 special-view">
          <div class="vl"></div>
        </div>
        <div
          class="half-section expert-p flex flex-col justify-center items-center"
        >
          <div class="bg-white container-how px-made m-made">
            <p class="font-semi-title text-made">¿Comó lo hacemos?</p>
          </div>
          <div class="flex justify-center px-expert-list">
            <ul class="list-disc">
              <li class="text-white text-xl mb-6 text-left font-semi-title">
                Entregas directas
              </li>
              <li class="text-white text-xl mb-6 text-left font-semi-title">
                Entregas en almacenes o CEDIS Indec México
              </li>
              <li class="text-white text-xl mb-6 text-left font-semi-title">
                Plan de Consignación
              </li>
            </ul>
          </div>
        </div>
        <transition name="fade2">
          <div
            v-if="showExp"
            class="bg-white px-4 shadow child rounded-custom pb-4 pt-12"
          >
            <p class="text-xl text-left-sp font-semi-title line-height-sp">
              Tenemos la visión 10+1, a corto plazo, es decir nos visualizamos
              operando una tercera parte del territorio nacional con relaciones
              consolidadas y CEDIS, así como una estructura de proceso de
              distribución sostenible y sustentable.
            </p>
            <div
              class="shadow rounded-full flex justify-center items-center custom-bg-primary child-2 w-20 h-20"
            >
              <img class="w-40" :src="lentes" alt="lentes" />
            </div>
          </div>
        </transition>
      </div>
    </section>
    <!-- <section id="expertos">
      <div class="custom-bg-primary container-expert relative py-16">
        <div class="half-section flex flex-col items-center padding-expert">
          <h1 class="text-white custom-widt-exp2 text-left text-exp font-semi-title">Somos</h1>
          <div class="bg-white mx-8 custom-widt-exp2">
            <h1 class="text-exp font-semi-title">Expertos</h1>
          </div>
          <div class="flex expert-images justify-between my-10">
            <div class="flex flex-col">
              <img class="expert-img-icon" :src="logistica" alt="logistica" />
              <h3 class="text-white mt-4 font-semi-title text-xl">Logística</h3>
            </div>
            <div class="flex flex-col">
              <img class="expert-img-icon" :src="distribucion" alt="distribucion" />
              <h3
                class="text-white mt-4 w-32 font-semi-title text-xl"
              >Distribución Envases de Plastico</h3>
            </div>
          </div>
        </div>
        <div class="flex items-center w-1 special-view">
          <div class="vl"></div>
        </div>
        <div class="half-section expert-p flex flex-col justify-center items-center">
          <div class="bg-white self-end px-made rounded-l-lg m-made">
            <p class="font-semi-title text-made">¿Comó lo hacemos?</p>
          </div>
          <div class="flex justify-center px-expert-list">
            <ul class="list-disc">
              <li class="text-white text-xl mb-6 text-left font-semi-title">Entregas directas</li>
              <li
                class="text-white text-xl mb-6 text-left font-semi-title"
              >Entregas en almacenes o CEDIS Indec México</li>
              <li class="text-white text-xl mb-6 text-left font-semi-title">Plan de Consignación</li>
            </ul>
          </div>
        </div>
        <div class="bg-white px-4 shadow child rounded-custom pb-4 pt-10">
          <p class="text-xl font-semi-title line-height-sp">
            Tenemos la visión 10+1, a corto plazo, es decir nos
            <br />visualizamos operando una tercera parte del territorio
            <br />nacional con relaciones consolidadas y CEDIS, así como
            <br />una estructura de proceso de distribución sostenible
            <br />y
            sustentable.
          </p>
          <div
            class="shadow rounded-full flex justify-center items-center custom-bg-primary child-2 w-20 h-20"
          >
            <img class="w-40" :src="lentes" alt="lentes" />
          </div>
        </div>
      </div>
    </section>-->
    <!-- <section id="por-que-nosotros">
      <div>
        <div class="back-image grid grid-cols-2 special-why">
          <div class="flex flex-col pd-why justify-center items-center">
            <h1 class="custom-widt-why text-left text-sp-why  font-semi-title">
              ¿Por qué
            </h1>
            <div class="custom-bg-transparent mx-why px-4">
              <h1 class="text-sp-why text-white font-semi-title">Nosotros?</h1>
            </div>
          </div>
          <div class="grid md:grid-cols-2 lg:grid-cols-3 grid-cols-3 grid-rows-3 py-6">
            <div class="flex justify-center items-center">
              <div class="shadow relative pt-square flex justify-center items-center square rounded-custom-2 custom-bg-transparent mx-12 px-4">
                <h1 class="text-lg text-white  line-height-sp font-semi-title">
                  Entregas éxitosas
                </h1>
                <h1 class="absolute child-5 text-6xl text-white font-semi-title z-10 text-shw">
                  +2,000
                </h1>
              </div>
            </div>
            <div class=" special-view"></div>
            <div class="flex justify-center items-center">
              <div class="shadow relative flex justify-center pt-square items-center square rounded-custom-2 custom-bg-transparent mx-12 px-4">
                <h1 class="text-lg line-height-sp text-white font-semi-title">
                  Estados de la Republica en Cobertura
                </h1>
                <h1 class="absolute child-3 text-6xl text-white font-semi-title z-10 text-shw">
                  +9
                </h1>
              </div>
            </div>
            <div></div>
            <div class=" special-view"></div>
            <div></div>
            <div class="flex justify-center items-center">
              <div class="shadow relative flex justify-center items-center pt-square square rounded-custom-2 custom-bg-transparent mx-12 px-4">
                <h1 class="text-lg line-height-sp text-white font-semi-title">
                  Empresas que han confiado en nosotros
                </h1>
                <h1 class="absolute child-3 text-6xl text-white font-semi-title z-10 text-shw">
                  +250
                </h1>
              </div>
            </div>
            <div class=" special-view"></div>
          </div>
        </div>
        <div class="fle items-center justify-center flex-col special-view-why container-why">
          <div class="flex justify-center items-center mb-10">
            <div class="shadow relative pt-square flex justify-center items-center square2 rounded-custom-2 custom-bg-transparent mx-2 px-4">
              <h1 class="text-lg text-white  line-height-sp font-semi-title">
                Entregas éxitosas
              </h1>
              <h1 class="absolute child-5 text-6xl text-white font-semi-title z-10 text-shw">
                +2,000
              </h1>
            </div>
          </div>
          <div class="flex justify-center items-center mb-10">
            <div class="shadow relative flex justify-center pt-square items-center square2 rounded-custom-2 custom-bg-transparent mx-2 px-4">
              <h1 class="text-lg line-height-sp text-white font-semi-title">
                Estados de la Republica en Cobertura
              </h1>
              <h1 class="absolute child-3 text-6xl text-white font-semi-title z-10 text-shw">
                +9
              </h1>
            </div>
          </div>
          <div class="flex justify-center items-center mb-10">
            <div class="shadow relative flex justify-center items-center pt-square square2 rounded-custom-2 custom-bg-transparent mx-2 px-4">
              <h1 class="text-lg line-height-sp text-white font-semi-title">
                Empresas que han confiado en nosotros
              </h1>
              <h1 class="absolute child-3 text-6xl text-white font-semi-title z-10 text-shw">
                +250
              </h1>
            </div>
          </div>
        </div>
      </div>
    </section>-->
    <section id="por-que-nosotros">
      <div>
        <div class="back-image grid grid-cols-2 special-why">
          <div class="flex flex-col pd-why justify-center items-center">
            <h1 class="custom-widt-why text-left text-sp-why font-semi-title">
              ¿Por qué
            </h1>
            <div class="custom-bg-transparent mx-why px-4">
              <h1 class="text-sp-why text-white font-semi-title">Nosotros?</h1>
            </div>
          </div>
          <div
            class="grid md:grid-cols-2 lg:grid-cols-3 grid-cols-3 grid-rows-3 py-6"
          >
            <div></div>
            <div class="flex justify-center items-center">
              <transition name="fade">
                <div
                  v-if="showNos"
                  class="shadow relative pt-square flex justify-center items-center square rounded-custom-2 custom-bg-transparent mx-12 px-4"
                >
                  <h1 class="text-lg text-white line-height-sp font-semi-title">
                    Entregas éxitosas
                  </h1>
                  <h1
                    class="absolute child-5 text-6xl text-white font-semi-title z-10 text-shw"
                  >
                    +2,000
                  </h1>
                </div>
              </transition>
            </div>
            <div class="special-view"></div>
            <div class="flex justify-center items-center">
              <transition name="fade">
                <div
                  v-if="showNos"
                  class="shadow relative flex justify-center pt-square items-center square rounded-custom-2 custom-bg-transparent mx-12 px-4"
                >
                  <h1 class="text-lg line-height-sp text-white font-semi-title">
                    Estados de la Republica en Cobertura
                  </h1>
                  <h1
                    class="absolute child-3 text-6xl text-white font-semi-title z-10 text-shw"
                  >
                    +9
                  </h1>
                </div>
              </transition>
            </div>
            <div></div>
            <div class="special-view"></div>
            <div></div>
            <div class="flex justify-center items-center">
              <transition name="fade">
                <div
                  v-if="showNos"
                  class="shadow relative flex justify-center items-center pt-square square rounded-custom-2 custom-bg-transparent mx-12 px-4"
                >
                  <h1 class="text-lg line-height-sp text-white font-semi-title">
                    Empresas que han confiado en nosotros
                  </h1>
                  <h1
                    class="absolute child-3 text-6xl text-white font-semi-title z-10 text-shw"
                  >
                    +250
                  </h1>
                </div>
              </transition>
            </div>
            <div class="special-view"></div>
          </div>
        </div>
        <div
          class="fle items-center justify-center flex-col special-view-why container-why"
        >
          <div class="flex justify-center items-center mb-10">
            <transition name="fade">
              <div
                v-if="showNos"
                class="shadow relative pt-square flex justify-center items-center square2 rounded-custom-2 custom-bg-transparent mx-2 px-4"
              >
                <h1 class="text-lg text-white line-height-sp font-semi-title">
                  Entregas éxitosas
                </h1>
                <h1
                  class="absolute child-5 text-6xl text-white font-semi-title z-10 text-shw"
                >
                  +2,000
                </h1>
              </div>
            </transition>
          </div>
          <div class="flex justify-center items-center mb-10">
            <transition name="fade">
              <div
                v-if="showNos"
                class="shadow relative flex justify-center pt-square items-center square2 rounded-custom-2 custom-bg-transparent mx-2 px-4"
              >
                <h1 class="text-lg line-height-sp text-white font-semi-title">
                  >Estados de la Republica en Cobertura
                </h1>
                <h1
                  class="absolute child-3 text-6xl text-white font-semi-title z-10 text-shw"
                >
                  +9
                </h1>
              </div>
            </transition>
          </div>
          <div class="special-view"></div>

          <div class="flex justify-center items-center mb-10">
            <transition name="fade">
              <div
                v-if="showNos"
                class="shadow relative flex justify-center items-center pt-square square2 rounded-custom-2 custom-bg-transparent mx-2 px-4"
              >
                <h1 class="text-lg line-height-sp text-white font-semi-title">
                  Empresas que han confiado en nosotros
                </h1>
                <h1
                  class="absolute child-3 text-6xl text-white font-semi-title z-10 text-shw"
                >
                  +250
                </h1>
              </div>
            </transition>
          </div>
          <div class="special-view"></div>
        </div>
      </div>
    </section>
    <section id="unete">
      <div class="u-container">
        <div class="u-width flex p-form flex-col justify-center items-center">
          <div
            class="special-une flex justify-center px-4 w-9/12 items-center custom-bg-blue mb-6"
          >
            <h1 class="font-semi text-white text-une">Únete</h1>
          </div>
          <form @submit.prevent="sendMail()">
            <input
              v-model="dataMail.name"
              class="border-solid shadow appearance-none custom-border mb-3 border rounded w-full py-2 px-3 font-semi-title text-secondary leading-tight focus:outline-none focus:shadow-outline"
              id="name"
              type="text"
              placeholder="Nombre*"
            />
            <input
              v-model="dataMail.email"
              class="border-solid shadow appearance-none custom-border mb-3 border rounded w-full py-2 px-3 font-semi-title text-secondary leading-tight focus:outline-none focus:shadow-outline"
              id="emial"
              type="email"
              placeholder="Email*"
            />
            <input
              v-model="dataMail.city"
              class="border-solid shadow appearance-none mb-3 border custom-border rounded w-full py-2 px-3 font-semi-title text-secondary leading-tight focus:outline-none focus:shadow-outline"
              id="city"
              type="text"
              placeholder="Ciudad"
            />
            <textarea
              v-model="dataMail.message"
              class="border-solid shadow appearance-none mb-3 border custom-border rounded w-full py-2 px-3 font-semi-title text-secondary focus:outline-none focus:shadow-outline"
              id="message"
              name="comment"
              cols="30"
              rows="5"
              placeholder="¿Por qué te gustaria
  distribuir con nosotros?"
            ></textarea>
            <div class="form-button w-full">
              <button
                type="submit"
                class="float-left custom-bg-primary btn-primary shadow p-1 swal2-confirm swal2-styled"
              >
                Enviar
              </button>
            </div>
          </form>
        </div>
        <div class="u-width">
          <div
            class="special-une-2 flex float-right pl-4 w-9/12 items-center custom-bg-blue mt-12"
          >
            <h1 class="font-semi text-white text-une">Únete</h1>
          </div>
          <div class="w-full flex pl-8 justify-center">
            <ul class="list-disc mt-8">
              <li class="font-semi-title mb-3 text-xl text-left">
                Sé Socio / Partner
                <div class="flex justify-center mt-3">
                  <a href="tel:+3328207272">
                    <img class="w-12" :src="phone" alt="Telefono" />
                  </a>
                  <a
                    href="mailto:carlos.alvarado@indecmexico.com?Subject=Me%20gustaría%20distribuir%20con%20ustedes"
                  >
                    <img class="w-12" :src="mail" alt="Email" />
                  </a>
                  <a
                    href="https://wa.me/5213328207272?text=Me%20gustaría%20distribuir%20con%20ustedes.`"
                  >
                    <img class="w-12" :src="whatsapp" alt="Whatsapp" />
                  </a>
                </div>
              </li>
              <li class="font-semi-title mb-3 text-xl text-left">
                ¿Quierés hablar con alguién?
                <div class="flex justify-center mt-3">
                  <a href="tel:+3322647692">
                    <img class="w-12" :src="phone" alt="Telefono" />
                  </a>
                  <a
                    href="mailto:ventas@indecmexico.com?Subject=Me%20gustaría%20distribuir%20con%20ustedes"
                  >
                    <img class="w-12" :src="mail" alt="Email" />
                  </a>
                  <a
                    href="https://wa.me/5213328207272?texto=Me%20gustaría%20distribuir%20con%20ustedes.`"
                  >
                    <img class="w-12" :src="whatsapp" alt="Whatsapp" />
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="custom-bg-secondary py-4">
        <h4 class="text-white font-semi-title">
          Priv. 5 de Mayo 1921, Bodega 7
        </h4>
        <h4 class="text-white font-semi-title">
          Agua Blanca Industrial, Zapopan,Jal.
        </h4>
        <h4 class="text-white font-semi-title">
          <span class="mr-3">CP.45235</span>
          <span class="ml-3">33 2264 7692</span>
        </h4>
      </div>
    </section>
    <footer>
      <div class="flex justify-center items-center py-6">
        <h3 class="font-footer">
          Todos los derechos reservados 2020 INDEC By CEIOPACK Group
        </h3>
      </div>
      <div class="flex justify-end bg-black w-full py-1 px-3">
        <p class="text-white font-footer-sp">by:</p>
        <a
          class="text-white font-footer-sp ml-1"
          href="https://vainilladev.com/"
          >Vainilladev</a
        >
        <a
          class="text-white font-footer-sp ml-1"
          href="https://malmocreative.com/"
          >Malmo creative</a
        >
      </div>
    </footer>
  </div>
</template>

<!-- ======================================================================================= 
 * ======================================= SCRIPT ==========================================
 * ========================================================================================= -->
<script>
import logo from "../assets/images/logo-web.png";
// import logoWeb from "../assets/images/Logo-2.png";
import videoIndec from "../assets/images/INDEC.mp4";
import corusel1 from "../assets/images/Home.png";
import corusel2 from "../assets/images/Home-1.jpg";
import corusel3 from "../assets/images/Home-2.jpg";
import corusel4 from "../assets/images/Home-3.jpg";
import nosotros from "../assets/images/Nosotros.png";
import distribucion from "../assets/images/Distribucion.png";
import logistica from "../assets/images/Logistica.png";
import phone from "../assets/images/phone.png";
import mail from "../assets/images/mail.png";
import whatsapp from "../assets/images/whatsapp.png";
import facebook from "../assets/images/facebook.png";
import leftArrow from "../assets/images/left-arrow.png";
import next from "../assets/images/next.png";
import lentes from "../assets/images/lentes.png";
import vainillaDevBlue from "../assets/images/Logo-VD-DarkBlue.png";
import { Slide } from "vue-burger-menu";

import { VueAgile } from "vue-agile";

export default {
  name: "HomePage",

  components: { agile: VueAgile, slide: Slide },
  data() {
    return {
      dataMail: {
        name: null,
        email: null,
        city: null,
        message: "",
        emailTo: "ventas@indecmexico.com, carlos.alvarado@indecmexico.com",
        subject: ""
      },
      logo: logo,
      videoIndec: videoIndec,
      image1: corusel1,
      image2: corusel2,
      image3: corusel3,
      image4: corusel4,
      image5: logo,
      nosotros: nosotros,
      distribucion: distribucion,
      logistica: logistica,
      phone: phone,
      vainillaDevBlue: vainillaDevBlue,
      mail: mail,
      open: false,
      whatsapp: whatsapp,
      facebook: facebook,
      leftArrow: leftArrow,
      next: next,
      lentes: lentes,
      show: false,
      showExp: false,
      showNos: false
    };
  },

  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    toggle() {
      this.open = !this.open;
    },
    sendMail() {
      if (this.dataMail.name && this.dataMail.email) {
        this.dataMail.subject = "Deseo información | " + this.dataMail.name + " | " + this.dataMail.city;
        this.axios
          .post("/contact-us", this.dataMail)
          .then(response => {
            this.$alert(
              "",
              response.data.message,
              "success"
            );
          })
          .catch(() => {
            this.$alert(
              "Puedes contactarnos mediante los botones del costado derecho",
              "Falla al enviar el correo",
              "error"
            );
          });
      }
      if (!this.dataMail.name) {
        this.$alert(
          "Ayudanos agregando tu nombre, ¡Queremos conocerte!",
          "Cuidado",
          "error"
        );
      }
      if (!this.dataMail.email) {
        this.$alert(
          "Necesitamos tu dirección de correo para contactarte",
          "Cuidado",
          "error"
        );
      }
    },

    handleScroll() {
      const width = window.innerWidth;

      let scroll1 = 600;
      let scroll2 = 1200;
      let scroll3 = 2000;

      width < 790 ? ((scroll1 = 70), (scroll2 = 80), (scroll3 = 1600)) : "";

      if (window.scrollY > scroll1) {
        this.show = true;
      }
      if (window.scrollY > scroll2) {
        this.showExp = true;
      }
      if (window.scrollY > scroll3) {
        this.showNos = true;
      }
    }
  }
};
</script>

<!-- ======================================================================================= 
 * ======================================= STYLE ===========================================
 * ========================================================================================= -->
<style>
@import url("https://fonts.googleapis.com/css?family=Montserrat:400,600,700&display=swap");

::-webkit-scrollbar {
  display: none;
}
.top-carusel {
  top: 90px;
}
.agile__nav-button {
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
  border: none;
  color: #fff;
  cursor: pointer;
  font-size: 24px;
  height: 40px;
  position: absolute;
  /* transform: translate(-50%, -50%); */
  top: 48%;
  margin-left: 2rem;
  margin-right: 2rem;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  width: 40px;
  border-radius: 50%;
}
.agile__nav-button:hover {
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 1;
}
.agile__nav-button--prev {
  left: 0;
  display: flex;
  justify-content: center;
  padding-right: 0.5rem;
}
.agile__nav-button--next {
  right: 0;
  display: flex;
  justify-content: center;
  padding-left: 0.5rem;
}
.agile__dots {
  bottom: 10px;
  left: 50%;
  position: absolute;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}
.agile__dot {
  margin: 0 10px;
}
.agile__dot button {
  background-color: transparent;
  border: 1px solid #00095c;
  border-radius: 50%;
  cursor: pointer;
  display: block;
  height: 10px;
  font-size: 0;
  line-height: 0;
  margin: 0;
  padding: 0;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  width: 10px;
}
.agile__dot--current button,
.agile__dot:hover button {
  background-color: #fff;
}
.slide {
  display: flex;
  justify-content: center;
  height: 900px;
  -o-object-fit: cover;
  object-fit: cover;
  width: 100%;
  justify-content: center;
  padding: 2rem;
}
.image-border {
  height: 100% !important;
}
.video-border {
  border-radius: 1rem;
  /* height: 100% !important; */
}
.custom-height {
  max-height: auto;
}
.img-height {
  height: 850px;
  width: 100%;
}
.font-semi {
  font-family: "Montserrat", sans-serif;
  font-weight: bold;
  font-size: 1.3rem;
  line-height: 23px;
}
.line-height-sp {
  line-height: 23px;
}
.font-semi-title {
  font-family: "Montserrat", sans-serif;
  font-weight: bold;
}
.custom-bg-blue {
  background-color: #00095c;
  height: 80px;
  width: 320px;
  margin: auto;
}
.left-center {
  left: 38%;
}
.right-center {
  right: 38%;
}
.special-padding {
  padding-top: 3%;
}
.top-center {
  right: 12%;
}
.custom-bg-primary {
  background-color: #00095c !important;
}
.custom-bg-secondary {
  background-color: #00095c;
}
.custom-bg-transparent {
  background-color: rgba(0, 9, 92, 0.8);
}
.custom-widt-exp {
  width: 400px;
}
.custom-widt-why {
  width: 400px;
}
.custom-widt-exp2 {
  width: 340px;
}
.vl {
  border-left: 1px solid white;
  height: 300px;
}
.back-image {
  background: url("../assets/images/Porque.jpg") center;
  height: 650px;
  background-size: cover;
  /* background-size: 100% 100%; */
  background-repeat: no-repeat;
}
.custom-border {
  border-color: #31387c !important;
  border-width: 2px !important;
}
.text-secondary {
  color: #31387c;
}
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #31387c;
  opacity: 1; /* Firefox */
}
.btn-primary {
  width: 125px;
  background-color: #00095c;
  color: white;
}
.child {
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.child-2 {
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.child-3 {
  position: absolute;
  top: 0%;
  left: 10%;
  transform: translate(-50%, -50%);
}
.child-4 {
  position: absolute;
  top: 50%;
  left: 30%;
  transform: translate(-50%, -50%);
}
.child-5 {
  position: absolute;
  top: 0%;
  left: 25%;
  transform: translate(-50%, -50%);
}

.rounded-custom {
  border-radius: 2rem;
}
.rounded-custom-2 {
  border-radius: 2.5rem;
}

.text-shw {
  text-shadow: 2px 8px 6px rgba(0, 0, 0, 0.2),
    0px -5px 35px rgba(255, 255, 255, 0.3);
}
.text-sm-ts {
  font-size: 3rem;
}
.sp-br {
  height: 0.6rem;
}
.half-section {
  width: 50%;
}
.section-sp1 {
  display: flex;
}
.text-left-sp {
  text-align: justify;
}
.margin-sp-n {
  margin-bottom: 0rem;
}
.container-expert {
  display: flex;
}
.text-sp-why {
  font-size: 4rem;
}
.pd-why {
  padding: 1rem;
}
.mx-why {
  margin: 0 3rem;
}
.p-form {
  padding: 4rem;
}
.text-une {
  font-size: 4rem;
}
.pt-square {
  padding-top: 0.5rem;
}
.arrow-buton {
  width: 64px;
}
.py-n-sp {
  padding: 0;
}
.pxs-text {
  padding: 0 3rem;
}
.expert-images {
  width: 70%;
  display: flex;
}
.expert-p {
  padding-top: 2.5rem;
}
.px-expert-list {
  padding: 0;
}
.padding-expert {
  padding: 2.5rem;
}
.container-why {
  height: 710px;
  padding: 2.5rem 0.5rem 1rem;
  background-color: #e3e3e3;
}
.square2 {
  width: 180px;
  height: 180px;
}
.square {
  width: 75%;
  height: 75%;
}
.u-container {
  display: flex;
}
.u-width {
  width: 50%;
}
.text-exp {
  font-size: 4rem;
}
.px-made {
  padding-right: 1.5rem;
  padding-left: 1.5rem;
}
.m-made {
  margin-bottom: 5rem;
}
.text-made {
  font-size: 3rem;
}
.list-clients {
  margin: 0 2rem;
}
.font-footer {
  font-family: "Montserrat", sans-serif;
  font-weight: bold;
  font-size: 1rem;
  width: 80%;
}
.font-footer-sp {
  font-family: "Montserrat", sans-serif;
  font-size: 0.6rem;
  font-weight: 600;
}
.footer-width {
  width: 100px;
}
.form-button {
  display: flex;
  justify-content: center;
}
.expert-img-icon {
  width: 8rem;
}
.img-footer {
  position: absolute;
  left: 95%;
}
.nosotros-title {
  font-size: 3.8rem;
}
.container-how {
  align-self: flex-end;
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.2s;
  animation: bounce-in 1.8s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.fade2-enter-active,
.fade2-leave-active {
  transition: opacity 2s;
}
.fade2-enter, .fade2-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

@media (max-width: 1350px) {
  .slide {
    height: 800px;
  }
  .text-sm-ts {
    font-size: 2.5rem;
  }
}

@media (max-width: 1100px) {
  .slide {
    height: 700px;
  }
  .text-sm-ts {
    font-size: 2.2rem;
  }
  .custom-height {
    height: 650px;
  }
  .img-height {
    height: 900px;
  }
}

@media (max-width: 1024px) {
  .agile__nav-button {
    font-size: 18px;
    height: 64px;

    margin-left: 2rem;
    margin-right: 2rem;
    width: 64px;
    top: 60%;
  }
  .arrow-buton {
    width: 32px;
  }
  .child {
    width: 70%;
  }
  .py-n-sp {
    height: 900px;
  }
  .custom-height {
    height: 900px;
  }
  .special-padding {
    padding-top: 3%;
  }
  .pxs-text {
    padding: 0 1.2rem;
  }
  .expert-images {
    width: 70%;
  }
  .px-expert-list {
    padding: 0 0.5rem 0 2rem;
  }
}

@media (max-width: 950px) {
  .slide {
    height: 550px;
    padding: 1.6rem;
  }
  .text-sm-ts {
    font-size: 1.8rem;
  }
  .img-footer {
    left: 90%;
  }
}

@media (max-width: 600px) {
  .slide {
    max-height: 300px;
    padding: 1.5rem;
  }
  .text-sm-ts {
    font-size: 1.2rem;
  }
}

@media (max-width: 450px) {
  .special-why {
    display: none !important;
  }
  .slide {
    max-height: 250px;
    padding: 1rem;
  }
  .text-sm-ts {
    font-size: 0.9rem !important;
  }
  .child-4 {
    left: 38%;
  }
  .text-left-sp {
    font-size: 1rem;
  }
  .section-sp1 {
    padding: 3rem 0rem 12rem !important;
  }
  .padding-expert {
    padding: 6rem 1.2rem 2rem !important;
  }
  .expert-images {
    width: 90%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .expert-img-icon {
    width: 6rem;
    margin-top: 1.2rem;
  }
  .u-container {
    flex-wrap: wrap;
  }
  .u-width {
    width: 100%;
  }
  .text-exp {
    font-size: 2.5rem;
  }
  .px-made {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .m-made {
    margin-bottom: 3rem;
  }
  .text-made {
    font-size: 2rem;
  }
  .custom-widt-exp2 {
    width: 310px;
  }
  .list-clients {
    margin: 0 1.2rem 0 1.6rem;
  }
  .font-footer {
    font-size: 0.8rem;
  }
  .special-une-2 {
    display: none !important;
  }
  .container-how {
    align-self: center;
    border-radius: 0.5rem;
  }
  .p-form {
    padding: 2rem 2rem 0.5rem !important;
  }
}

@media (max-width: 790px) {
  .slide {
    height: 450px;
  }
  .special-view {
    display: none !important;
  }
  .agile__nav-button {
    display: none !important;
  }
  .text-sm-ts {
    font-size: 1.4rem;
  }
  .half-section {
    width: 100% !important;
  }
  .section-sp1 {
    align-items: center;
    justify-items: center;
    padding: 3rem 0rem 10rem;
  }
  .text-left-sp {
    text-align: justify;
  }
  .child {
    width: 85%;
  }
  .margin-sp-n {
    margin-bottom: 0.8rem;
  }
  .container-expert {
    flex-wrap: wrap;
  }
  .text-sp-why {
    font-size: 2.5rem;
  }
  .mx-why {
    margin: 0 2rem;
  }
  .custom-widt-why {
    width: 300px;
  }
  .p-form {
    padding: 2rem;
  }
  .text-une {
    font-size: 2.5rem;
  }
  .py-n-sp {
    height: auto;
  }
  .expert-p {
    padding-top: 0.5rem;
  }
  .padding-expert {
    padding: 2rem;
  }
}

@media (min-width: 790px) {
  .special-view-menu {
    display: none !important;
  }
}

@media (min-width: 450px) {
  .special-view-why {
    display: none !important;
  }
  .special-une {
    display: none !important;
  }
}

/* @media (max-width: 680px) {
  .full-sm-width {
    width: 100% !important;
  }
  .sm-txt-al {
    text-align: left !important;
  }
  .sm-ml-4 {
    margin-left: 0.3rem;
  }
  .sm-px-6 {
    padding: 0.25rem 0;
  }
} */
</style>
